import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { useState, useCallback, useEffect } from 'react';
import { RequestStatus } from '@lib/plugin-redux-core';
import { useDispatch, useSelector } from 'react-redux';
import { getUseCase } from '@lib/plugin-redux-core';
import { VALIDATE_PUBLIC_FILE_URL_USE_CASE } from '../../../../file-storage';
import { validatePublicFileUrlStatusSelector, validatePublicFileUrlOutputSelector } from '../../redux/file-storage/file-storage.selectors';
import { UniqueEntityID } from '@digibricks/domains';
export var useImportUrl = function useImportUrl() {
  var _useState = useState([]),
      urls = _useState[0],
      setUrls = _useState[1];

  var _useState2 = useState(''),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(null),
      error = _useState3[0],
      setError = _useState3[1];

  var _useState4 = useState(null),
      validatingUrl = _useState4[0],
      setValidatingUrl = _useState4[1];

  var _useState5 = useState(false),
      isValidatingState = _useState5[0],
      setIsValidatingState = _useState5[1];

  var dispatch = useDispatch(); // Get status from Redux

  var validatePublicFileUrlStatus = useSelector(validatePublicFileUrlStatusSelector);
  var validatePublicFileUrlOutput = useSelector(validatePublicFileUrlOutputSelector);
  var isRequestExecuting = validatePublicFileUrlStatus === RequestStatus.EXECUTE;
  var isValidating = isRequestExecuting || isValidatingState; // Monitor validatePublicFileUrl success and update local state

  useEffect(function () {
    if (validatePublicFileUrlStatus === RequestStatus.SUCCESS && validatePublicFileUrlOutput && validatingUrl) {
      // Add the validated URL to local state
      setUrls(function (prev) {
        var newUrl = {
          id: new UniqueEntityID().toString(),
          url: validatingUrl,
          fileName: validatePublicFileUrlOutput.fileName,
          fileSize: validatePublicFileUrlOutput.fileSize
        }; // Check if already exists and add if not

        var exists = prev.some(function (u) {
          return u.url === newUrl.url;
        });

        if (!exists) {
          return [].concat(_toConsumableArray(prev), [newUrl]);
        }

        return prev;
      }); // Clear the validating URL and reset validation state

      setValidatingUrl(null);
      setIsValidatingState(false);
    } else if (validatePublicFileUrlStatus === RequestStatus.ERROR) {
      // Clear the validating URL and reset validation state on error
      setValidatingUrl(null);
      setIsValidatingState(false);
    }
  }, [validatePublicFileUrlStatus, validatePublicFileUrlOutput, validatingUrl]);
  var handleInputChange = useCallback(function (e) {
    setInputValue(e.target.value);
    setError(null); // Clear error when user starts typing
  }, []); // 2. VALIDATE_PUBLIC_FILE_URL_USE_CASE integration

  var addUrl = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
      var isDocumentURL, validatePublicFileUrlInput, validatePublicFileUrlUseCase;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setError(null); // Client-side validation first

              isDocumentURL = /^http.*\.pdf$/.test(url);

              if (isDocumentURL) {
                _context.next = 6;
                break;
              }

              setError('Invalid URL format. Must start with "http" and have .pdf extension');
              return _context.abrupt("return");

            case 6:
              if (!urls.some(function (existing) {
                return existing.url === url;
              })) {
                _context.next = 9;
                break;
              }

              setError('This URL has already been added');
              return _context.abrupt("return");

            case 9:
              // Set validation state and URL being validated for tracking
              setIsValidatingState(true);
              setValidatingUrl(url); // Call VALIDATE_PUBLIC_FILE_URL_USE_CASE

              validatePublicFileUrlInput = {
                url: url
              };
              validatePublicFileUrlUseCase = getUseCase(VALIDATE_PUBLIC_FILE_URL_USE_CASE, dispatch);
              validatePublicFileUrlUseCase.execute(validatePublicFileUrlInput);
              _context.next = 21;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              setError((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || 'Failed to validate URL');
              setValidatingUrl(null);
              setIsValidatingState(false);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 16]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [urls]); // 3. Local state only - no server call

  var removeUrl = useCallback(function (urlId) {
    setError(null); // Update local state only

    setUrls(function (prev) {
      return prev.filter(function (url) {
        return url.id !== urlId;
      });
    });
  }, []);
  var clearUrls = useCallback(function () {
    setUrls([]);
    setInputValue('');
    setError(null);
    setValidatingUrl(null);
    setIsValidatingState(false);
  }, []);
  return {
    urls: urls,
    isValidating: isValidating,
    error: error,
    addUrl: addUrl,
    removeUrl: removeUrl,
    clearUrls: clearUrls,
    handleInputChange: handleInputChange,
    inputValue: inputValue
  };
};